import React from "react";
import Marquee from "react-fast-marquee";

const CREDITS = [
  "Produced by",
  "Engineered by",
  "Mixed by",
  "Mastered by",
  "Written by",
  "Tour Managed by",
  "Photographed by",
  "Directed by",
  "Performed by",
  "A&R by",
  "Assistant Engineer",
  "Session Musician",
  "Sound Designer",
  "Booked by",
  "Featuring",
  "Lighting by",
  "Recorded at",
];

export const CreditsTicker = ({ className = "" }) => {
  return (
    <div
      className={`marquee-fade pointer-events-none select-none ${className}`}
      data-testid="credits-ticker"
    >
      <Marquee gradient={false} speed={32} pauseOnHover={false}>
        {CREDITS.concat(CREDITS).map((c, i) => (
          <span
            key={i}
            className="mx-10 font-display text-2xl md:text-4xl uppercase tracking-[0.06em] text-white/15"
          >
            {c}
            <span className="mx-6 inline-block h-1 w-1 -translate-y-2 rounded-full bg-loudar-orange/60" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default CreditsTicker;
